import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Answer } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ExaminationSessionActions } from '../examination-session/examination-session.actions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const ANSWER_FEATURE_KEY: string = 'answer';

// eslint-disable-next-line
export interface AnswerState extends EntityState<Answer> {}

export const answerAdapter: EntityAdapter<Answer> =
  createEntityAdapter<Answer>();

export const initialAnswerState: AnswerState = answerAdapter.getInitialState(
  {},
);

const reducer: ActionReducer<AnswerState, Action> = createReducer(
  initialAnswerState,
  on(AuthActions.logoutSuccess, (): AnswerState => initialAnswerState),
  on(
    ExaminationSessionActions.getExaminationSessionDetailedSuccess,
    (state, action): AnswerState =>
      answerAdapter.upsertMany(
        action.examinationSession.answers.map((answer) => ({
          ...answer,
          examinationSessionId: action.examinationSession.id,
        })),
        {
          ...state,
        },
      ),
  ),
);

export function answerReducer(
  state: AnswerState | undefined,
  action: Action,
): AnswerState {
  return reducer(state, action);
}
